import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { buildHeaders3beu05fiq9iq2 as buildHeaders } from '../utils/headers.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { PlatformUtils_getInstanceitqdjrwn2jrm as PlatformUtils_getInstance } from '../../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_KTOR_DEFAULT_USER_AGENT() {
  _init_properties_Utils_kt__jo07cx();
  return KTOR_DEFAULT_USER_AGENT;
}
var KTOR_DEFAULT_USER_AGENT;
function get_DATE_HEADERS() {
  _init_properties_Utils_kt__jo07cx();
  return DATE_HEADERS;
}
var DATE_HEADERS;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var KtorCallContextElementClass;
function KtorCallContextElement() {
  if (KtorCallContextElementClass === VOID) {
    class $ {
      constructor(callContext) {
        this.x5l_1 = callContext;
      }
      r3() {
        return Companion_instance;
      }
    }
    protoOf($).hd = get;
    protoOf($).nm = fold;
    protoOf($).mm = minusKey;
    protoOf($).om = plus;
    initMetadataForClass($, 'KtorCallContextElement', VOID, VOID, [Element()]);
    KtorCallContextElementClass = $;
  }
  return KtorCallContextElementClass;
}
function callContext($completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.rc();
  return ensureNotNull(tmp$ret$0.hd(Companion_instance)).x5l_1;
}
function mergeHeaders(requestHeaders, content, block) {
  _init_properties_Utils_kt__jo07cx();
  var tmp = buildHeaders(($this$buildHeaders) => {
    $this$buildHeaders.i4o(requestHeaders);
    $this$buildHeaders.i4o(content.a50());
    return Unit_instance;
  });
  tmp.j4o((key, values) => {
    var tmp;
    if ('Content-Length' === key) {
      return Unit_instance;
    }
    var tmp_0;
    if ('Content-Type' === key) {
      return Unit_instance;
    }
    var tmp_1;
    if (get_DATE_HEADERS().y2(key)) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = values.u1();
      while (_iterator__ex2g4s.v1()) {
        var element = _iterator__ex2g4s.w1();
        block(key, element);
      }
      tmp_1 = Unit_instance;
    } else {
      var separator = 'Cookie' === key ? '; ' : ',';
      tmp_1 = block(key, joinToString(values, separator));
    }
    return Unit_instance;
  });
  var missingAgent = requestHeaders.l2o('User-Agent') == null && content.a50().l2o('User-Agent') == null;
  if (missingAgent && needUserAgent()) {
    block('User-Agent', get_KTOR_DEFAULT_USER_AGENT());
  }
  var tmp0_safe_receiver = content.g47();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? content.a50().l2o('Content-Type') : tmp1_elvis_lhs;
  var type = tmp2_elvis_lhs == null ? requestHeaders.l2o('Content-Type') : tmp2_elvis_lhs;
  var tmp3_safe_receiver = content.h47();
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
  var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? content.a50().l2o('Content-Length') : tmp4_elvis_lhs;
  var length = tmp5_elvis_lhs == null ? requestHeaders.l2o('Content-Length') : tmp5_elvis_lhs;
  if (type == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    block('Content-Type', type);
  }
  if (length == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    block('Content-Length', length);
  }
}
function needUserAgent() {
  _init_properties_Utils_kt__jo07cx();
  return !PlatformUtils_getInstance().o4n_1;
}
var properties_initialized_Utils_kt_xvi83j;
function _init_properties_Utils_kt__jo07cx() {
  if (!properties_initialized_Utils_kt_xvi83j) {
    properties_initialized_Utils_kt_xvi83j = true;
    KTOR_DEFAULT_USER_AGENT = 'ktor-client';
    DATE_HEADERS = setOf(['Date', 'Expires', 'Last-Modified', 'If-Modified-Since', 'If-Unmodified-Since']);
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  callContext as callContext9kaeu539wjs3,
  KtorCallContextElement as KtorCallContextElementudwxlrp3zgdl,
  mergeHeaders as mergeHeadersub4y73mj759y,
};
//endregion

//# sourceMappingURL=Utils.mjs.map
